import { useTranslation } from "react-i18next";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, ExternalLink } from "lucide-react";
import type { Printable } from "@/data/printables";

interface Props {
  printable: Printable | null;
  onClose: () => void;
  onDownload: (p: Printable) => void;
}

const PrintablePreviewDialog = ({ printable, onClose, onDownload }: Props) => {
  const { t } = useTranslation();
  const open = !!printable;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-5xl w-[95vw] h-[90vh] flex flex-col p-0 gap-0">
        {printable && (
          <>
            <DialogHeader className="p-4 border-b flex-shrink-0">
              <DialogTitle className="font-heading">{t(printable.titleKey)}</DialogTitle>
              <DialogDescription className="sr-only">{t(printable.descriptionKey)}</DialogDescription>
            </DialogHeader>
            <div className="flex-1 min-h-0 bg-muted">
              <iframe
                src={`${printable.pdf}#toolbar=1&view=FitH`}
                title={t(printable.titleKey)}
                className="w-full h-full border-0"
              />
            </div>
            <div className="p-4 border-t flex flex-wrap items-center justify-end gap-3 flex-shrink-0">
              <Button asChild variant="outline" size="sm" className="rounded-full">
                <a href={printable.pdf} target="_blank" rel="noopener noreferrer">
                  <ExternalLink className="mr-2 h-4 w-4" /> {t("activities.printables.openInNewTab")}
                </a>
              </Button>
              <Button asChild size="sm" className="rounded-full bg-primary text-primary-foreground font-bold">
                <a
                  href={printable.pdf}
                  download={`queebi-${printable.slug}.pdf`}
                  onClick={() => onDownload(printable)}
                >
                  <Download className="mr-2 h-4 w-4" /> {t("activities.printables.download")}
                </a>
              </Button>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default PrintablePreviewDialog;
